<nj-toast toastId="toast-1" [hasCloseIcon]="true" [shouldDismiss]="true" iconName="check" 
>
<!--  (closed)="closed.emit($event)"
  (dismissed)="dismissed.emit()">
-->
  {{Title}}
  <ng-container njToastBody>
    {{Message}}
  </ng-container>
</nj-toast>